import React, { useEffect, useState } from 'react'
import {
    calcMoneyFood,
    checkCanFastAdd,
    checkTimeCanAddFood,
    formatMoney,
    getFoodPriceShow,
} from '../../utils'
import * as actions from '../../actions/orderActions'
import { clsx } from '../../utils/helper'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { getCurrentGroupOrder, getRestaurantSettings } from '../../selectors'
import useMoney from '../../hooks/useMoney'

import FoodItemDesk from '../../components/desktop/food/FoodItemDesk'
import WrapIcon from '../../components/elements/WrapIcon'
import { ReactComponent as IconAdd } from '../../assets/icons/add.svg'
import GroupTopping from '../../components/desktop/food/GroupTopping'
import FormatCurrency from '../../components/elements/FormatCurrency'
import { Modal } from 'antd-mobile'
import AmountButton from '../../components/elements/AmountButton'
import MaskAdded from '../../assets/icons/mask_added_bot.png'
import InputSelect from '../../components/form/InputSelect'
import useFood from '../../hooks/useFood'
import useOrder from '../../hooks/useOrder'
const alert = Modal.alert

const defaultForm = {
    amount: 1,
    note: '',
    index: -1,
}

const FoodItemContainer = ({
    food,
    beilageFoodShowing,
    setBeilageFoodShowing,
    setMoreInfo,
    hasInCart,
}) => {
    const getFoodShow = () => {
        if (!food?.subs) {
            return food
        }

        return food.subs[foodSubShowIndex]
    }

    const { in_vat = 0 } = useSelector(getRestaurantSettings)
    const currentGroupOrder = useSelector(getCurrentGroupOrder);
    const [foodSubShowIndex, setFoodSubShowIndex] = useState(0)
    const { addToCart } = useOrder();

    const [formData, setFormData] = useState({
        ...defaultForm,
        beilageItems: [],
    })

    const dispatch = useDispatch()
    const { t } = useTranslation()

    const validFoodTime = checkTimeCanAddFood(food)
    const isBeilageShowing = beilageFoodShowing === food.id
    const foodShowing = getFoodShow()
    const { beilageItems = [] } = foodShowing || {}
    const { subs } = food || {}
    const { isFoodSoldOut: isFoodCurrentSoldOut } = useFood(foodShowing);
    const { isFoodSoldOut: isFoodParentSoldOut } = useFood(food);

    const money = useMoney(calcMoneyFood, {
        foodDetails: foodShowing,
        ...formData,
    })

    const handleChange = (name, value) => {
        if (name === 'amount' && value < 1) {
            return
        }
        setFormData(oldData => ({
            ...oldData,
            [name]: value,
        }))
    }

    const handleSubmit = () => {
        for (let i = 0; i < beilageItems.length; i++) {
            if (
                beilageItems[i].option &&
                (!formData.beilageItems[i] ||
                    formData.beilageItems[i].every(el => !el))
            ) {
                alert(
                    '',
                    t('message.beilageRequire', {
                        group: beilageItems[i].group_name,
                    }),
                    [{ text: 'Ok', onPress: () => console.log('ok') }]
                )
                return
            }
        }
        const { currentPrice, saleOfPercent, isHappyHour } = money

        addToCart({
            ...formData,
            foodDetails: {
                ...foodShowing,
                currentPrice: foodShowing.currentPrice ?? currentPrice,
                saleOfPercent,
                foodParent: food.subs && food,
            },
            isHappyHour,
            vat: in_vat,
            groupOrder: currentGroupOrder
        });

        setBeilageFoodShowing(-1);
    }

    const handleClickAdd = () => {
        if (!validFoodTime || isFoodParentSoldOut) {
            return
        }

        if (checkCanFastAdd(food)) {
            !isFoodCurrentSoldOut && handleSubmit()
        } else {
            setBeilageFoodShowing(food.id)
        }
    }

    const handleClickClose = () => {
        setBeilageFoodShowing(-1)
    }

    const handleChangeTopping = (indexGroup, indexTopping) => {
        let newData = { ...formData }
        if (newData.beilageItems[indexGroup]) {
            let groupTopping = [...newData.beilageItems[indexGroup]]
            const { type } = foodShowing.beilageItems[indexGroup]
            const hasChecked = groupTopping[indexTopping]

            type !== 1 && (groupTopping = [])
            groupTopping[indexTopping] = !hasChecked

            newData.beilageItems[indexGroup] = groupTopping
        } else {
            let rs = []
            rs[indexTopping] = true
            newData.beilageItems[indexGroup] = rs
        }
        setFormData(newData)
    }

    useEffect(() => {
        !isBeilageShowing && setFormData({ ...defaultForm, beilageItems: [] })
    }, [isBeilageShowing])

    return (
        <div
            className={clsx([
                'food-item-desk',
                isBeilageShowing && 'open',
                !validFoodTime && 'disable-action',
                isFoodParentSoldOut && 'food-out-stock'
            ])}
        >
            <div
                className="btn-toggle"
                onClick={isBeilageShowing ? handleClickClose : handleClickAdd}
            >
                <WrapIcon
                    className={clsx([isBeilageShowing && 'close'])}
                    icon={IconAdd}
                    size="14px"
                    className={isBeilageShowing ? 'open' : ''}
                />
            </div>

            {hasInCart && (
                <div onClick={handleClickAdd} className="mask-added">
                    <img src={MaskAdded} width="80px" />
                </div>
            )}

            <FoodItemDesk
                food={food}
                showBeilage={isBeilageShowing}
                handleClickAdd={handleClickAdd}
                handleClickClose={handleClickClose}
                setMoreInfo={setMoreInfo}
                isFoodSoldOut={isBeilageShowing ? isFoodCurrentSoldOut : isFoodParentSoldOut}
            />

            {isBeilageShowing && (
                <>
                    <div className="topping">
                        {subs?.length && (
                            <div className="row py-2">
                                <div className="col-md-6">
                                    <InputSelect
                                        options={subs.map((el, index) => (
                                            <option key={el.id} value={index}>
                                                {el.name} ({formatMoney(getFoodPriceShow(el).currentPrice)})
                                            </option>
                                        ))}
                                        value={foodSubShowIndex}
                                        onChange={e =>
                                            setFoodSubShowIndex(e.target.value)
                                        }
                                    />
                                </div>
                            </div>
                        )}
                        <div className="row">
                            {beilageItems.map((group, index) => (
                                <div
                                    key={group.group_name}
                                    className="col-md-6 mt-4"
                                >
                                    <GroupTopping
                                        handleChangeTopping={indexTopping => handleChangeTopping(index, indexTopping)}
                                        listChecked={formData.beilageItems[index] || []}
                                        item={group}
                                        setMoreInfo={setMoreInfo}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="text-center p-6 group-action">
                        <div className="d-inline-flex change-amount">
                            <AmountButton
                                onClick={() =>
                                    handleChange('amount', formData.amount - 1)
                                }
                            />

                            <div className="px-4 heading-5 amount">
                                {formData.amount}
                            </div>

                            <AmountButton
                                add
                                onClick={() =>
                                    handleChange('amount', formData.amount + 1)
                                }
                            />
                        </div>

                        <button
                            style={{ minWidth: '300px' }}
                            className={clsx("primary-button ml-6", (isFoodCurrentSoldOut || !validFoodTime) && 'add-desk-disabled')}
                            onClick={handleSubmit}
                            disabled={isFoodCurrentSoldOut || !validFoodTime}
                        >
                            <FormatCurrency amount={money?.total || 0} />
                            {!!money?.originPrice && (
                                <FormatCurrency
                                    className="origin-price-desk"
                                    amount={money.originPrice}
                                />
                            )}
                        </button>
                    </div>
                </>
            )}
        </div>
    )
}

export default FoodItemContainer
